<as-split direction="vertical">
  <as-split-area size="75"
                 class="py-3">
    <router-outlet></router-outlet>
  </as-split-area>

  @if (isTerminalOpen()) {
    <as-split-area size="25">
      <era-raw></era-raw>
    </as-split-area>
  }
</as-split>